import { createRouter, createWebHashHistory } from 'vue-router'
import Login from '../components/login.vue'
import Main from '../components/main.vue'
import Domp from '../components/domp.vue'
import totle from '../components/comp/title.vue'
import YeasCard from '../components/comp/YeasCard.vue'
const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/main',
    name: 'Main',
    component: Main
  },
  {
    path: '/domp',
    name: 'Domp',
    component: Domp,
    children: [
      {
        path: '', 
        component: totle
      },
      {
        path: '/domp/YeasCard', 
        component: YeasCard
      },
    ]
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router